export default __webpack_public_path__ + "static/media/Amrish Thanga Maligai.b65e2997.jpg";